import api from '@/libs/api'
import rotasAPI from '@/router/rotasAPI'
import helpers from '@/helpers'
import { resetRouter } from '@/router/index'

window.Pusher = require('pusher-js')

const defaultCount = parseInt(process.env.VUE_APP_SESSION_EXPIRED) | 7200

const state = {
  count: defaultCount,
  token: null,
  userData: null,
  refCount: null,
}

const mutations = {
  DEFINE_LOGGED_USER(state, { userData }) {
    state.userData = userData
    state.token = userData.auth.access_token
  },
  RESET_LOGGED_USER(state, { userData }) {
    state.userData = userData
    state.token = userData.auth.access_token
  },
  DEFINE_NAME_USER(state, name) {
    state.userData.full_name = name
  },

  LOGOUT_USER(state) {
    state.token = null
    state.userData = {}
  },
  START_COUNT(state) {
    if (state.token && state.userData) {
      clearInterval(state.refCount)
      state.count = defaultCount
      state.refCount = null

      state.refCount = setInterval(() => {
        state.count--
      }, 1000)
    }
  },
  STOP_COUNT(state) {
    clearInterval(state.refCount)
    state.count = defaultCount
    state.refCount = null
  },
  SET_COUNT(state, newCount) {
    state.count = newCount
  },
  SET_REF_COUNT(state, newRefCount) {
    state.refCount = newRefCount
  },
  SET_ABILITY(state, data) {
    state.userData.ability = data.ability !== undefined ? data.ability : data
  }
}

const actions = {
  login({ commit }, userCredentials ) {
    const route = userCredentials.admin ? rotasAPI.LoginAdmin : rotasAPI.Login

    return new Promise((resolve, reject) => {
      api
        .post(route, userCredentials.userData)
        .then(response => {
          const res = response.data
          commit('DEFINE_LOGGED_USER', {
            userData: res
          })

          helpers.PusherAuth(response.data.auth.access_token)

          commit('START_COUNT')
          resetRouter()
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  logout({ commit }) {
    commit('LOGOUT_USER')
    commit('STOP_COUNT')
    resetRouter()
  },

  startCount({ commit }) {
    commit('START_COUNT')
  },
  setCount({ commit }, newCount) {
    commit('SET_COUNT', newCount)
  },

  resetCompany({ commit }, loginData ) {
    commit('RESET_LOGGED_USER', {
      userData: loginData
    })

    helpers.PusherAuth(loginData.auth.access_token)

    commit('START_COUNT')
  }
}

const getters = {
  isLoggedIn: state => Boolean(state.token && state.userData),
  getCount: state => () => state.count
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
